import React from "react";
import { formatEasyTime } from "../../utils/time";
import HeroIcon from "../common/HeroIcon";

export function getPastIdeaStatus(idea) {
  const videos = Array.isArray(idea?.videos) ? idea.videos : [];
  const scripts = Array.isArray(idea?.scripts) ? idea.scripts : [];
  if (idea?.has_video || videos.length > 0) {
    return { label: "Video generated", className: "text-theme-primary" };
  }
  if (idea?.has_script || scripts.length > 0) {
    return { label: "Script generated", className: "text-theme-text opacity-80" };
  }
  if (idea?.queue_status === "dismissed") {
    return { label: "Rejected", className: "text-theme-text opacity-60" };
  }
  if (idea?.queue_status === "queued") {
    return { label: "Queued", className: "text-theme-primary" };
  }
  return { label: "Processed", className: "text-theme-text opacity-60" };
}

const PastIdeasRail = ({
  ideas,
  loading,
  error,
  highlightedHash,
  onOpenIdea,
}) => {
  if (ideas.length === 0) return null;

  return (
    <section className="min-h-[260px]">
      <div className="pb-3 border-b border-theme-shadow">
        <h2 className="text-base font-semibold text-theme-text">Past ideas</h2>
        <p className="text-xs text-theme-text opacity-60 mt-1">
          Scripts, videos, and rejected ideas
        </p>
      </div>

      <div className="max-h-[calc(100vh-18rem)] overflow-y-auto">
        {error ? (
          <p className="text-sm text-theme-text opacity-70 py-4">{error}</p>
        ) : loading ? (
          <p className="text-sm text-theme-text opacity-60 py-4">Loading past ideas...</p>
        ) : (
          <div className="divide-y divide-theme-shadow">
            {ideas.map((idea) => {
              const status = getPastIdeaStatus(idea);
              const isHighlighted = highlightedHash === idea.hash;
              return (
                <button
                  key={idea.hash}
                  type="button"
                  onClick={() => onOpenIdea?.(idea)}
                  className={`w-full flex items-center gap-3 p-3 text-left transition-colors duration-500 ${
                    isHighlighted ? "bg-theme-secondary" : "hover:bg-theme-secondary"
                  }`}
                >
                  <span className="w-9 h-9 rounded-lg bg-theme-secondary flex items-center justify-center flex-shrink-0">
                    {idea.emoji ? (
                      <span className="text-base leading-none">{idea.emoji}</span>
                    ) : (
                      <HeroIcon name="light-bulb" className="w-4 h-4 text-theme-text opacity-60" />
                    )}
                  </span>
                  <span className="min-w-0 flex-1">
                    <span className="block text-xs font-medium text-theme-text truncate">
                      {idea.title || "Untitled idea"}
                    </span>
                    <span className="mt-1 flex items-center justify-between gap-2">
                      <span className={`text-[10px] font-medium ${status.className}`}>{status.label}</span>
                      {idea.resolved_at || idea.create_date ? (
                        <span className="text-[10px] text-theme-text opacity-40 whitespace-nowrap">
                          {formatEasyTime(idea.resolved_at || idea.create_date)}
                        </span>
                      ) : null}
                    </span>
                  </span>
                </button>
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
};

export default PastIdeasRail;
